import { ApiEpBilling } from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.billing.plansubscription.exchange_rate";

export const useQueryBillingExchangeRate = (
  params: Parameters<typeof ApiEpBilling.Plansubscription.exchangeRate>[0],
  options?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiEpBilling.Plansubscription.exchangeRate>>
    >,
    "queryKey" | "queryFn"
  >,
) =>
  useQuery<
    Await<ReturnType<typeof ApiEpBilling.Plansubscription.exchangeRate>>
  >(
    [KEY, params.query],
    () => ApiEpBilling.Plansubscription.exchangeRate(params),
    options,
  );

useQueryBillingExchangeRate.KEY = KEY;
